import React, { forwardRef } from 'react'
import BoxContainer from '../../../../components/common/containers/BoxContainer'
import I18n from '../../../../helpers/I18n'

interface BoxProps {
  subTitle?: React.ReactNode
  hideBorder?: boolean
}

const Steps: React.FC<{ children: any }> = ({ children }) => <div className='roi-calculator-steps'>{children}</div>

const StepInner: React.FC<{ className?: string, children: any }> = ({ className, children }) => (
  <div className={className || 'roi-calculator-step-inner'}>{children}</div>
)

export const StepOne = forwardRef<HTMLDivElement, BoxProps & React.HTMLProps<HTMLDivElement>>(
  ({ subTitle, hideBorder = true, children, ...rest }, ref) => (
    <BoxContainer
      title={I18n.t('views.roi_calculator.form.headings.manual_process')}
      hideBorder={hideBorder}
      subTitle={subTitle}
      subTitleElementType='span'
      {...rest}
      ref={ref}
    >
      <StepInner>{children}</StepInner>
    </BoxContainer>
  )
)

export const StepTwo = forwardRef<HTMLDivElement, BoxProps & React.HTMLProps<HTMLDivElement>>(
  ({ subTitle, hideBorder = true, children, ...rest }, ref) => (
    <BoxContainer
      title={I18n.t('views.roi_calculator.form.headings.process_details')}
      hideBorder={hideBorder}
      subTitle={subTitle}
      subTitleElementType='span'
      {...rest}
      ref={ref}
    >
      <StepInner className='roi-calculator-step-inner-container'>{children}</StepInner>
    </BoxContainer>
  )
)

export default Steps
